import React, { useState } from 'react'
import { Formik } from 'formik'
import { useQuery, useMutation } from  '../../Hooks/graphql_utils'
import { gql } from '@apollo/client'
import { useNavigate, useLocation } from 'react-router-dom'
import { useToast } from '../../Hooks/toast'
import { ColorRecipeForm } from './ColorRecipeForm.js'
import { PebbleColorSchema } from '@mmg/validation'
import { Spinner } from '../../Elements'


const PEBBLE_COLOR_FRAGMENT = gql`
    fragment PebbleColorFragment on PebbleColor {
        id
        name
        material_type {
            id
            name
        }
        recipe {
            id
            product {
                id
                name
            }
            quantity
        }
    }
`

const QUERY = gql`
${PEBBLE_COLOR_FRAGMENT}
{   
    lookupPebbleColor {
        ...PebbleColorFragment
    }
    lookupPebbleColorMaterialType {
        id
        name
    }
    lookupProductsForPebbleColorRecipes {
        id
        name
        supplier {
            id
            name
        }
    }
}
`

const MUTATION = gql`
    mutation UpdatePebbleColor($pebbleColor: PebbleColorInput!) {
        updatePebbleColor(pebbleColor: $pebbleColor) {
            ...PebbleColorFragment
        }
    }
    ${PEBBLE_COLOR_FRAGMENT}
`

export default () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { showSuccess, showError } = useToast()
    const [updatePebbleColor] = useMutation(MUTATION)
    const [isCreationMode, setIsCreationMode] = useState(false)

    const [fetchedData, setFetchedData] = useState([])

    const { loading, error, data, networkStatus, refetch } = useQuery(QUERY, {
        notifyOnNetworkStatusChange: true,
        onCompleted: (d) => setFetchedData(d)
    })

    if (loading && networkStatus !== 4) {
        return (
            <Spinner />
        )
    }

    if (error) {
        return (
            <p>error</p>
        )
    }

    let initialSelectedColor = location?.state?.selectedId
        ? data.lookupPebbleColor.find(c => c.id === location.state.selectedId)
        : ''

    const onSubmit = async (values, { setFieldValue }) => {
        const model = PebbleColorSchema.cast(values, { stripUnknown: true })
        const colorToSubmit = model.selected_color
        await updatePebbleColor({
            variables: {
                pebbleColor: colorToSubmit
            }
        })
            .then(async ({ data: resData }) => {
                showSuccess('Success!')
                let selectedId = resData.updatePebbleColor.id
                if (isCreationMode) {
                    refetch()
                    setIsCreationMode(false)
                    setFieldValue('selected_color', resData.updatePebbleColor)
                }

                navigate('.', { state: { selectedId: selectedId } })
            })
            .catch(() => showError('Error, please try again.'))
    }

    const onReset = () => navigate('/')

    return (
        <Formik
            initialValues={{ selected_color: initialSelectedColor, ...data }}
            onReset={onReset}
            onSubmit={(values, helpers) => onSubmit(values, helpers)}
            isRefetching={networkStatus === 4}
            render={props => {
                return <ColorRecipeForm
                    {...props}
                    values={{ ...props.values, ...fetchedData }}
                    isCreationMode={isCreationMode}
                    setIsCreationMode={setIsCreationMode}
                />
            }}
            validationSchema={PebbleColorSchema}
        />
    )
}